import { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";
import { api, API_BASE, getToken, setConfirmationApplies, setToken } from "../api/client";

const AuthContext = createContext(null);

export function AuthProvider(props) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const refreshMe = useCallback(async () => {
    if (!getToken()) {
      setUser(null);
      setLoading(false);
      return;
    }
    try {
      const data = await api.get("/admin/me");
      setUser(data.user);
    } catch (e) {
      setToken(null);
      setUser(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    refreshMe();
  }, [refreshMe]);

  const signIn = useCallback(() => {
    window.location.href = `${API_BASE}/auth/google/admin`;
  }, []);

  useEffect(() => {
    setConfirmationApplies(Boolean(user && user.isAdmin));
  }, [user]);

  const signOut = useCallback(() => {
    setToken(null);
    setUser(null);
  }, []);

  const value = useMemo(
    () => ({
      user,
      loading,
      isMentor: Boolean(user && (user.isMentor || user.isAdmin)),
      isSuperAdmin: Boolean(user && user.isAdmin),
      signIn,
      signOut,
      refreshMe,
    }),
    [user, loading, signIn, signOut, refreshMe]
  );

  return <AuthContext.Provider value={value}>{props.children}</AuthContext.Provider>;
}

export function useAuth() {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error("useAuth must be used inside AuthProvider");
  return ctx;
}
